export default __webpack_public_path__ + "static/media/PROMOCION110326.c66a4992.jpeg";